import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../services/http.service';

import { AppointmentsTableComponent } from '../appointments-table/appointments-table.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { StorageService } from '../../services/storage.service';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { elements } from 'chart.js';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-invoices-methods-payment',
  imports: [AppointmentsTableComponent, TranslateModule, NzDividerModule],
  templateUrl: './invoices-methods-payment.component.html',
  styleUrls: ['./invoices-methods-payment.component.scss'],
})
export class InvoicesMethodsPaymentComponent implements OnInit {
  payments: any[] = [];
  columns: any;
  appointmentsText: any;
  isSecondUser: boolean = false;
  userData: any;
  filters: { first: any[]; innerSelectData: any[] } = {
    first: [],
    innerSelectData: [],
  };

  constructor(
    private http: HttpService,
    private translateService: TranslateService,
    private storage: StorageService,
    private router: Router
  ) {}

  ngOnInit() {
    this.getPayments();
    this.getData();
    this.translateService.onLangChange.subscribe(() => {
      this.getData();
    });
  }

  private getPayments() {
    this.http.getPaymentsHistory().subscribe((res: any) => {
      if (res) {
        this.payments = [];
        res.forEach((data: any) => {
          this.payments.push({
            consultDate: new Date(data.creationDate).toLocaleDateString('it-IT', {
              day: '2-digit',
              month: 'long',
              year: 'numeric',
            }),
            name: data.state === 'PAGATO' ? '#' + data.contractNumber : '-',
            consultType: data.description,
            chargedBy: data.rateGrosAmount,
            rateNumber: data.rateNumber,
            status: data.state,
            statusText: data.state === 'IN_ATTESA' ? 'In attesa' : data.state.charAt(0).toUpperCase() + data.state.slice(1).toLowerCase(),
            fullNamePayment: `${data.beneficiaryFirstName} ${data.beneficiaryLastName}`,
            action: 'Dettaglio',
          });
        });
      }
    });
  }

  private getData() {
    this.translateService.get('personalArea.paymentMethods').subscribe((texts) => {
      this.columns = texts.columns;
    });
    this.translateService.get('personalArea.paymentMethods').subscribe((texts) => {
      this.appointmentsText = texts.appointmentsText;
    });
    this.isSecondUser = JSON.parse(<string>this.storage.getItem('oldUserData')) ? true : false;
    this.userData = JSON.parse(<string>this.storage.getItem('userData'));
    this.getInnerSelectData();
  }

  public changeUser() {
    const oldUserData = JSON.parse(<string>this.storage.getItem('oldUserData'));
    this.storage.removeItem('oldUserData');
    this.storage.setItem('userData', oldUserData);
    this.router.navigate(['/personal-area/invoices-and-methods-payment']);
  }

  private getInnerSelectData() {
    this.translateService.get('personalArea.paymentMethods').subscribe((texts) => {
      texts?.innerSelectData?.forEach((text: any) => {
        const innerSelectData = {
          placeholder: text.placeholder,
          label: text.label,
          texts: text.texts,
          elements: text.elements,
          control: new FormControl(null, [Validators.required]),
        };
        this.filters.innerSelectData.push(innerSelectData);
      });
    });
  }

  openPaymentDetail(payment: any) {
    this.router.navigate(['/personal-area/payment-details/' + payment.rateNumber]);
  }
}
